import React from 'react';
import { Button } from './Button';

interface FeaturePlaceholderProps {
  title: string;
  description?: string;
  icon?: string;
  primaryActionLabel?: string;
  onPrimaryAction?: () => void;
}

export function FeaturePlaceholder({ 
  title, 
  description, 
  icon = 'ri-tools-line',
  primaryActionLabel,
  onPrimaryAction
}: FeaturePlaceholderProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 border border-dashed border-slate-200 rounded-xl bg-slate-50/50">
      <div className="w-16 h-16 bg-slate-100 text-slate-400 rounded-3xl flex items-center justify-center mb-6 shadow-sm rotate-3">
        <i className={`${icon} text-3xl`}></i>
      </div>
      <h3 className="text-lg font-medium text-slate-800 mb-2">{title}</h3>
      <p className="text-sm text-slate-500 text-center max-w-md leading-relaxed mb-8">
        {description || `Tính năng ${title} đang được nhóm Landscape xây dựng và sẽ sớm ra mắt.`}
      </p>
      {primaryActionLabel && onPrimaryAction && (
        <Button variant="primary" size="md" onClick={onPrimaryAction}>
          {primaryActionLabel}
        </Button>
      )}
    </div>
  );
}
